import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';
import { AuthenticationService, UserService } from '../../services';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss', '../login/login.component.scss']
})
export class ResetPasswordComponent implements OnInit {

    input = {
        password: '',
        show: false
    }
    reinput = {
        password: '',
        show: false
    }

    username = ''
    token: string
    email: string
    errorMess: string
    processing = false
    loaded = false

    constructor(private route: ActivatedRoute,
        private toastr: ToastsManager,
        private vRef: ViewContainerRef,
        private router: Router,
        private authService: AuthenticationService) {
        this.toastr.setRootViewContainerRef(vRef);
    }

    ngOnInit() {
        this.token = this.route.snapshot.queryParams?.token
        if (!this.token) {
            this.errorMess = 'Invalid link.'
            this.loaded = true
            setTimeout(() => {
                this.router.navigate(['/forgot-password']);
            }, 2000);
        }
        else {
            this.authService.decodeToken({ token: this.token })
                .subscribe((res: any) => {
                    this.loaded = true
                    if (res) {
                        this.email = res
                        return
                    }
                    this.errorMess = 'Invalid or expired link.'
                    setTimeout(() => {
                        this.router.navigate(['/forgot-password']);
                    }, 2000);
                }, (err: any) => {
                    this.loaded = true
                    if (err?.message?.includes('expired')) {
                        this.errorMess = 'This link was already expired.'
                    }
                    this.errorMess = 'Invalid or expired link.'
                    setTimeout(() => {
                        this.router.navigate(['/forgot-password']);
                    }, 2000);
                })
        }
    }

    changePassword() {
        this.processing = true
        var data = {
            password: this.input.password,
            userName: this.username
        }
        this.authService.ChangePassword(data)
            .subscribe((res: any) => {
                this.toastr.success(`Password updated successfully.`)

                setTimeout(() => {
                    this.router.navigate(['/login']);
                }, 1000);
            }, (err: any) => {
                this.processing = false
                this.toastr.error(err?.message ?? 'Username not found');
                return Observable.throw(err?.message ?? 'Username not found')
            })
    }
}



// WEBPACK FOOTER //
// ./src/app/components/reset-password/reset-password.component.ts